import { Component, OnInit, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessagesError } from '../classes/messages-error-type';
import { SystemTablesService } from "../services/system-tables.service";
import { QuestionnaireService } from '../services/questionnaire.service';

@Component({
	selector: 'app-add-borrower',
	templateUrl: './add-borrower.component.html',
	styleUrls: ['./add-borrower.component.scss'],
	// encapsulation: ViewEncapsulation.None
})
export class AddBorrowerComponent implements OnInit {

	@Input() qID: any = null;
	@Input() index: number;
	@Input() borrower: FormGroup;
	@Output() removed: EventEmitter<number> = new EventEmitter<number>();
	@Output() offError: EventEmitter<number> = new EventEmitter<number>();
	@Input() displayErrors: boolean;
	@Input() public childrenNumber: number[];
	@Input() public maritalStatus: string[];
	@Input() public showRemove: boolean;
	@Input() public status: string;
	@Input() public msgArr: Map<number, any>;
	@Input() public ifShowMessages: Array<MessagesError>;
	isMobilePrefixOnly: boolean = true;
	statusTable;
	proximity;
	isMarried = false;
	minBirthDate = { year: (new Date().getFullYear()) - 100, month: 1, day: 1 }; //from -100 years
	maxBirthDate = { year: (new Date().getFullYear()) - 15, month: 12, day: 31 };  //to 15 years old
	defaultValue = "";

	constructor(
		private systemTablesService: SystemTablesService,
		private questionnaireService: QuestionnaireService
	) { }

	ngOnInit() {
		let borrower = this.borrower
		this.proximity = this.systemTablesService.getTable('1708').map(k => k.name);
		this.statusTable = this.systemTablesService.getTable('1719').map(k => k.name);
		this.status = borrower.value.borrowerMaritalStatus;
		this.isMarried = this.status === 'נשוי/ה';
	}

	remove(index) {
		this.removed.emit(index)
		this.offError.emit()
	}

	static buildBorrower(val: any) {
		return new FormGroup({
			borrowerFullName: new FormControl(val ? val.borrowerFullName : ""),
			borrowerPhoneNumber: new FormControl(val ? val.borrowerPhoneNumber : ""),
			borrowerBirthDate: new FormControl(val ? val.borrowerBirthDate : ""),
			borrowerIdNumber: new FormControl(val ? val.borrowerIdNumber : ""),
			borrowerProximity: new FormControl(val ? val.borrowerProximity : ""),
			borrowerId: new FormControl(val ? val.borrowerId : ""),
			borrowerEmail: new FormControl(val ? val.borrowerEmail : ""),

		})
	}
}



// WEBPACK FOOTER //
// ./src/app/add-borrower/add-borrower.component.ts